import { COOKIES } from 'solidarity.module/common/domain/constants';

class WhatIsSolidayEuroFooterController {

  constructor(EventEmitter, cookieService, SolidarityUserDataService) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.cookieService = cookieService;
    this.solidarityUserDataService = SolidarityUserDataService;
  }

  ampInfo(){
    this.setDontShowAgain();
    this.clickAmplify(this.EventEmitter({state:true}));

  }

  setDontShowAgain() {
    if (!this.dontShowAgain) {
      return;
    }

    const employeeId = this.solidarityUserDataService._employee;
    const cookie = `${COOKIES.WHAT_IS_SOLIDARY_EURO}${employeeId}`;
    this.cookieService.put(cookie, this.dontShowAgain);
  }
}

export default WhatIsSolidayEuroFooterController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidayEuroFooter/whatIsSolidayEuroFooter.controller.js